import { useState, useCallback } from 'react';
import { pw9233Api } from '../../../services/pw9233Api';
import { F9430, F9431 } from '../../../services/pw9233Api';

export function usePW9233Lookup() {
  const [names, setNames] = useState<Record<string, string>>({});

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pw9233Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const resolveAllNames = useCallback(async (master: Partial<F9430>, firstDetail?: Partial<F9431>) => {
    const entries: [string, string, string][] = [
      ['employee', 'employee', master.f9430_01 || ''],
    ];
    if (firstDetail?.f9431_11) {
      entries.push(['salaryCode', 'salaryCode', firstDetail.f9431_11]);
    }
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pw9233Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveSingleName, resolveAllNames, clearNames };
}
